module.exports = __webpack_public_path__ + "static/media/octo_header.c5ec8ae3.jpg";